import { css, keyframes } from '@emotion/css';
import React from 'react';
import haniwas from '../../assets/images/img_image_haniwas.svg';

const frames = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -352px 0;
  }
`;

export const Haniwa: React.FC = () => {
  return (
    <div
      className={css`
        width: 88px;
        height: 88px;
        background-image: url(${haniwas});
        background-repeat: no-repeat;
        animation: ${frames} 1.01s steps(4, end) 0s infinite;
      `}
    />
  );
};
